module.exports = __webpack_public_path__ + "static/media/thanks-right.a1831dc3.png";